/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-30 19:49:41
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-09 16:22:50
 */
import { TableColumnType } from "antd";

export const MedicalDataColumn = (): TableColumnType<any>[] => {
  return [
    {
      title: "辖区",
      dataIndex: "urbanName",
      align: "center",
      key: "urbanName",
    },
    {
      title: "机构总数",
      align: "center",
      dataIndex: "total",
    },
    {
      title: "智能监管机构数",
      dataIndex: "organizationTotal",
      align: "center",
      key: "organizationTotal",
      sorter: (a, b, sorter) => {
        if (sorter === "ascend") {
          return a.urbanName === "合计"
            ? 1
            : a.organizationTotal - b.organizationTotal;
        } else {
          return a.urbanName === "合计"
            ? -1
            : a.organizationTotal - b.organizationTotal;
        }
      },
    },
    {
      title: "诊疗数",
      dataIndex: "medicalTotal",
      align: "center",
      key: "medicalTotal",
      sorter: (a, b, sorter) => {
        if (sorter === "ascend") {
          return a.urbanName === "合计" ? 1 : a.medicalTotal - b.medicalTotal;
        } else {
          return a.urbanName === "合计" ? -1 : a.medicalTotal - b.medicalTotal;
        }
      },
    },
    {
      title: "预警数",
      dataIndex: "cautionTotal",
      align: "center",
      key: "cautionTotal",
      sorter: (a, b, sorter) => {
        if (sorter === "ascend") {
          return a.urbanName === "合计" ? 1 : a.cautionTotal - b.cautionTotal;
        } else {
          return a.urbanName === "合计" ? -1 : a.cautionTotal - b.cautionTotal;
        }
      },
    },
    {
      // title: "执法数",
      title: "处置数",
      dataIndex: "handleTotal",
      align: "center",
      key: "handleTotal",
      sorter: (a, b, sorter) => {
        if (sorter === "ascend") {
          return a.urbanName === "合计" ? 1 : a.handleTotal - b.handleTotal;
        } else {
          return a.urbanName === "合计" ? -1 : a.handleTotal - b.handleTotal;
        }
      },
    },
    {
      title: "预警占比",
      dataIndex: "cautionRatio",
      align: "center",
      key: "cautionRatio",
      render: (_, t) => {
        return t.cautionTotal === 0 || t.medicalTotal === 0
          ? "-"
          : ((t.cautionTotal / t.medicalTotal) * 100).toFixed(2) + "%";
      },
      sorter: (a, b, sorter) => {
        const valA = Math.round(
          (a.medicalTotal ? a.cautionTotal / a.medicalTotal : 0) * 1000
        );
        const valB = Math.round(
          (b.medicalTotal ? b.cautionTotal / b.medicalTotal : 0) * 1000
        );
        if (sorter === "ascend") {
          return a.urbanName === "合计" ? 1 : valA - valB;
        } else {
          return a.urbanName === "合计" ? -1 : valA - valB;
        }
      },
    },
    {
      title: "处置占比",
      dataIndex: "handleRatio",
      align: "center",
      key: "handleRatio",
      render: (_, t) => {
        return t.handleTotal === 0 || t.medicalTotal === 0
          ? "-"
          : ((t.handleTotal / t.cautionTotal) * 100).toFixed(2) + "%";
      },
      sorter: (a, b, sorter) => {
        const valA = Math.round(
          (a.handleTotal ? a.cautionTotal / a.handleTotal : 0) * 1000
        );
        const valB = Math.round(
          (b.handleTotal ? b.cautionTotal / b.handleTotal : 0) * 1000
        );
        if (sorter === "ascend") {
          return a.urbanName === "合计" ? 1 : valA - valB;
        } else {
          return a.urbanName === "合计" ? -1 : valA - valB;
        }
      },
    },
  ];
};
